import { apiGrupoObtenerGruposInfo, apiGrupoObtenerHorario, apiGrupoObtenerMaestrosInfo } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, IGroup, IGrupoInfo, IInfoTeacher, ISchoolHour } from "../models/Entities";
import { RequestData } from "../utils/RequestData";

export const _GRUPOSINFO_MAP = new Map<number, IGrupoInfo>();
export function _SvGrupoObtenerGruposInfo(idsGrupos: number[]) {
    const params = {
        Ids: idsGrupos,
    }
    return new Promise<typeof _GRUPOSINFO_MAP>(resolve => {
        new RequestData<IApiResult<IGrupoInfo[]>>(apiGrupoObtenerGruposInfo)
            .Params(params)
            .Completion((response, error) => {
                const resultData: IGrupoInfo[] = response.Datos || [];
                if (error) {
                    console.log(error.name, error.message);
                }
                resultData.forEach(d => {
                    _GRUPOSINFO_MAP.set(d.Id, d);
                })
                resolve(_GRUPOSINFO_MAP);
            })
            .Get();
    })
}

export function _SvGrupoSetGruposInfoMap(grupos: IGroup[]) {
    grupos.forEach(d => {
        _GRUPOSINFO_MAP.set(d.IdGrupo, {
            Id: d.IdGrupo,
            Nombre: d.NombreGrupo,
        })
    })
}

export const _GRUPO_MAESTROSINFO_MAP: Map<number, IInfoTeacher> = new Map();
let maxDateTeacherInfo: string | null = null;
export function _SvGrupoObtenerMaestrosInfo(callback?: (data: Array<IInfoTeacher>) => void) {
    const params = {
        IdGrupo: _APP_DATA.userData.IdGrupo,
        Modificacion: maxDateTeacherInfo
    }

    new RequestData<IApiResult<IInfoTeacher[]>>(apiGrupoObtenerMaestrosInfo)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response?.Datos || [];
            if (error)
                console.log(error.name, error.message);
            resultData.forEach(item => {
                _GRUPO_MAESTROSINFO_MAP.set(item.IdTeacher, item);
            })

            let maxDate = response?.Maxima || null;
            if (resultData.length > 0 && maxDate != null)
                maxDateTeacherInfo = maxDate;
            if (resultData.length > 0 && callback) callback(resultData);
        }).Get()
}

export function _SvGrupoClearMaestrosInfoData() {
    _GRUPO_MAESTROSINFO_MAP.clear();
    maxDateTeacherInfo = null;
}

export const _GRUPO_HORARIOS_ALUMNOS_MAP: Map<number, ISchoolHour> = new Map();
export let maxDateSchedule: string | null = null;

export function _SvGrupoObtenerHorario(callback: (resul: Array<ISchoolHour>) => void) {
    let day: number = new Date().getDay();
    day = day > 0 ? day - 1 : 6;

    let params = {
        Dia: day,
        IdGrupo: _APP_DATA.userData.IdGrupo,
        Modificacion: maxDateSchedule
    };

    new RequestData<IApiResult<ISchoolHour[]>>(apiGrupoObtenerHorario)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response ? response.Datos : [];
            // let status = response ? response.Estado : -111;
            if (error)
                console.log(error.name, error.message);

            resultData.forEach(item => {
                let obj = Object.assign({}, item) as any;
                item.Entrada = obj.Entrada ? new Date(obj.Entrada) : null;
                item.Salida = obj.Salida ? new Date(obj.Salida) : null;

                if (!item.EnUso)
                    _GRUPO_HORARIOS_ALUMNOS_MAP.delete(item.IdAlumno);

                else
                    _GRUPO_HORARIOS_ALUMNOS_MAP.set(item.IdAlumno, item);
            });

            if (resultData.length > 0 && response)
                maxDateSchedule = response.Maxima;

            if (callback) callback(resultData);
        }).Get();
}

export function _SvGrupoClearHorarios() {
    _GRUPO_HORARIOS_ALUMNOS_MAP.clear()
    maxDateSchedule = null
}